import { GameFrame } from '@/features/game-client/game-frame';
import { gameContextSelector } from '@/features/game-context/store/game-context';
import {
  isBracketWrappedString,
  NORMALIZERS,
  pickStringish,
} from '@/features/providers/playtech/helpers';
import {
  FgpPlaytechLaunchData,
  FgpPlaytechPokerLaunchData,
} from '@/features/providers/playtech/types';
import { GameDataProp } from '@/features/providers/types';
import { useAppSelector } from '@/store/hooks';

export const Playtech: React.FC<GameDataProp> = ({ data }: GameDataProp) => {
  const { url } = (data as FgpPlaytechLaunchData | FgpPlaytechPokerLaunchData)
    .launchDetails;
  const { gameName, additionalConfigParams } =
    useAppSelector(gameContextSelector);

  const urlObj = new URL(url);
  const hasNativeParam = urlObj.searchParams.has('deliveryPlatform');
  const hasIntegrationParam = urlObj.searchParams.has('integration');

  if (
    additionalConfigParams?.parameters &&
    !urlObj.searchParams.has('parameters')
  ) {
    const parameters = additionalConfigParams.parameters.split('&');
    parameters.forEach((parameter) => {
      const [key, value] = parameter.split('=');
      urlObj.searchParams.append(key, value);
    });
  } else if (additionalConfigParams) {
    Object.entries(additionalConfigParams)
      .filter(([, value]) => value !== undefined && value !== null)
      .forEach(([key, value]) => {
        let paramKey = key === 'name1' ? 'name' : key;

        if (key === 'tags' && !Array.isArray(value)) {
          if (!isBracketWrappedString(value)) {
            paramKey = 'code';
          }
        }

        if (urlObj.searchParams.has(paramKey)) return;
        const lower = paramKey.toLowerCase();
        const normalize = NORMALIZERS[lower] ?? pickStringish;
        const normalized = normalize(value);
        if (normalized) urlObj.searchParams.append(paramKey, normalized);
      });
  }

  if (!hasNativeParam) urlObj.searchParams.append('deliveryPlatform', 'Native');
  if (!hasIntegrationParam) urlObj.searchParams.append('integration', 'ucip');

  return <GameFrame url={urlObj.toString()} title={gameName} />;
};
